import type { App } from 'vue';
import { createRouter, createWebHistory, RouteRecordRaw, useRoute } from 'vue-router';
import { useTitle } from '@/hooks/useTitle';
import { Session } from '@/utils/storage';
import { store } from '@/store';
import { storeToRefs } from 'pinia';
import { useRoutesList } from '@/store/router.store';
import { initMobileRoutes, initTrendsRoutes } from '@/utils/trends.unils';
import { mobileRouter } from './mobile.router';
import { docRouter } from './doc.router';

import MainLayout from '../layouts/web/Index.vue';
import MobileDetect from 'mobile-detect';
import { useCache } from '@/hooks/useCache';
import { useAppStore } from '@/store/app';
import { ElMessage } from 'element-plus';
const { wsCache } = useCache();

/* 系统页面路由 */
export const constantRouterMap: AppRouteRecordRaw[] = [
	{
		path: '/',
		name: '/',
		component: MainLayout,
		meta: {
			isKeepAlive: true,
		},
		children: [],
	},
	{
		path: '/login',
		name: 'WebLogin',
		component: () => import('@/views/Login/Index.vue'),
		meta: { hidden: true },
	},
	{
		path: '/404',
		component: () => import('@/views/error/index.vue'),
		name: 'NotFound',
		meta: { hidden: true },
	},
];

export const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	strict: true,
	routes: [...constantRouterMap, mobileRouter, docRouter] as RouteRecordRaw[],
	scrollBehavior: () => ({ left: 0, top: 0 }),
});

/* 非移动端进入这个处理路由 */
const InWebRouter = async (to: any, form: any, next: any, token: string) => {
	const isMobile = to.path.indexOf('mobile') >= 0;

	if ((to.path === '/login' || to.path === '/mobile/login') && !token) {
		next();
	} else {
		if (!token) {
			if (to.path !== '/login' || to.path !== '/mobile/login') {
				Session.clear();
				if (!isMobile) {
					next(`/login?redirect=${to.path}&params=${JSON.stringify(to.query ? to.query : to.params)}`);
				} else {
					next(`/mobile/login?redirect=${to.path}&params=${JSON.stringify(to.query ? to.query : to.params)}`);
				}
			} else {
				next();
			}
		} else if (token && to.path === '/login') {
			if (isMobile) {
				next('/mobile/tabs/welcome');
			} else {
				next('/home');
			}
		} else {			
			const routerStore = useRoutesList(store);
			const { routesList } = storeToRefs(routerStore);

			if (routesList.value.length === 0) {
				if(await initTrendsRoutes()){
					next({ path: to.path, query: to.query });
				}else{
					// 获取菜单失败，清除缓存，重新登录
					console.log('获取菜单失败！');
					ElMessage.error(`获取菜单失败！`);
					wsCache.clear();
					Session.clear();
					useAppStore().setLoginInfo({});
					window.location.reload();
				}
			} else {
				next();
			}
		}
	}
};

/* 移动端路由 */
const InMobilebRouter = async (to: any, form: any, next: any, token: string) => {
	if (!token) {
		if (to.path !== '/mobile/login') {
			Session.clear();
			next(`/mobile/login?redirect=${to.path}&params=${JSON.stringify(to.query ? to.query : to.params)}`);
		} else {
			next();
		}
	} else if (token && to.path === '/mobile/login') {
		next('/mobile/tabs/welcome');
	} else {
		await initMobileRoutes();
		next();
	}
};

/* 进入路由前 */
router.beforeEach(async (to, form, next) => {
	useTitle(to.meta.title as string);
	const token = Session.get('token') as string;

	// const mobileMd = new MobileDetect(window.navigator.userAgent);
	/*
	 *	老铁，这里刚开始规划的时候是打算移动端和Web端分开的
	 *	但是李老大(李年丰)不太想分多个域名，嫌管理方面麻烦
	 *	所以我只能把移动端和Web端放一起了，但这样做容易产生
	 *	一系列的神奇问题，现在，这成为接手的你的问题了！
	 *	Remark by 摸鱼王 2024年3月15日
	 */
	await InWebRouter(to, form, next, token);

	// if (to.path.indexOf('mobile') >= 0) {
	// 	await InMobilebRouter(to, form, next, token);
	// } else {
	// 	await InWebRouter(to, form, next, token);
	// }
});

export const setupRouter = (app: App<Element>) => {
	app.use(router);
};

export default router;
